'use client';

import { getConfig } from '@/utils/config/config';

export const getCookieValue = (cookieName: string, shouldDecode = true) => {
    if (typeof document === 'undefined') {
        return '';
    }

    const cookie = (document.cookie || '')
        .split(';')
        .map((item) => item.trim())
        .find((item) => cookieName === item.split('=')[0]);

    if (cookie) {
        const cValue: string = cookie.split('=')[1] || '';
        return shouldDecode ? decodeURIComponent(cValue) : cValue;
    }

    return '';
};

export const setCookie = (
    name: string,
    value: string,
    cookieLifetimeInMS?: number,
    path?: string,
    domain?: string,
    shouldEncode = true
) => {
    if (typeof document === 'undefined') {
        return;
    }

    const maxAgeAttr: string = !isNaN(Number(cookieLifetimeInMS))
        ? `; max-age=${Math.floor(cookieLifetimeInMS! / 1000)}`
        : '';
    const expiresAttr: string = !isNaN(Number(cookieLifetimeInMS))
        ? `; expires=${new Date(Date.now() + cookieLifetimeInMS!).toUTCString()}`
        : '';
    const pathAttr = `; path=${path ? path : '/'}`;
    const domainAttr = `; domain=${domain ? domain : getConfig()?.rootDomain}`;

    const cValue: string = value || '';
    const cookieValue: string = shouldEncode ? encodeURIComponent(cValue) : cValue;

    document.cookie = `${name}=${cookieValue}${maxAgeAttr}${expiresAttr}${pathAttr}${domainAttr}`;
};

export const removeCookie = (name: string, path?: string, domain?: string) => {
    if (typeof document === 'undefined') {
        return;
    }

    const maxAgeAttr = `; max-age=${0}`;
    const expiresAttr = `; expires=${new Date(0).toUTCString()}`;
    const pathAttr = `; path=${path ? path : '/'}`;
    const domainAttr = `; domain=${domain ? domain : getConfig()?.rootDomain}`;

    document.cookie = `${name}=${maxAgeAttr}${expiresAttr}${pathAttr}${domainAttr}`;
};
